export default {
  'admin.marketplace.title': 'Кураторство маркетплейса',
  'admin.marketplace.search': 'Поиск по названию',
  'admin.marketplace.filters.all': 'Все',
  'admin.marketplace.filters.featured': 'Рекомендуемые',
  'admin.marketplace.empty': 'Нет публичных подписок по вашим фильтрам.',
  'admin.marketplace.column.name': 'Название',
  'admin.marketplace.column.owner': 'Владелец',
  'admin.marketplace.column.total': 'Итоговая цена',
  'admin.marketplace.column.features': 'Функции',
  'admin.marketplace.column.clones': 'Клоны',
  'admin.marketplace.column.public': 'Публичная',
  'admin.marketplace.column.featured': 'Рекомендуемая',
  'admin.marketplace.column.created': 'Создана',
  'admin.marketplace.publicYes': 'Публичная',
  'admin.marketplace.toggle.success': 'Признак "рекомендуемая" обновлён',
  'admin.marketplace.toggle.error':
    'Не удалось обновить признак "рекомендуемая"',
  'admin.marketplace.features.title': 'Кураторство маркетплейса функций',
  'admin.marketplace.features.empty':
    'Нет публичных функций по вашим фильтрам.',
  'admin.marketplace.features.column.title': 'Название',
  'admin.marketplace.features.column.price': 'Цена',
};
